module.exports = __webpack_public_path__ + "static/ajuluchukwu-125029587b7976ba405085663c65019e.png";